import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {Fragment} from 'react'
import {useFragment} from 'react-relay'


import CardButton from '../../../../components/CardButton'
import IconLabel from '../../../../components/IconLabel'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import useMutationProps from '../../../../hooks/useMutationProps'

import {Card} from '../../../../types/constEnums'

import {USER_DASH} from '../../../../utils/constants'
import isTaskArchived from '../../../../utils/isTaskArchived'
import setLocalTaskError from '../../../../utils/relay/setLocalTaskError'
import OutcomeCardMessage from '../OutcomeCardMessage/OutcomeCardMessage'
import TaskFooterIntegrateToggle from './TaskFooterIntegrateToggle'
import TaskFooterTagMenuToggle from './TaskFooterTagMenuToggle'
import TaskFooterTeamAssignee from './TaskFooterTeamAssignee'
import TaskFooterUserAssignee from './TaskFooterUserAssignee'

const Footer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  maxWidth: '100%',
  padding: `8px ${Card.PADDING} ${Card.PADDING}`
})

const ButtonGroup = styled('div')(({cardIsActive}) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  opacity: cardIsActive ? 1 : 0
}))

// ButtonSpacer helps truncated names (…) be consistent
const ButtonSpacer = styled('div')({
  display: 'inline-block',
  height: 24,
  verticalAlign: 'middle',
  width: 24
})

const AvatarBlock = styled('div')({
  flex: 1,
  height: 24,
  minWidth: 0
})










const TaskFooter = (props) => {
  const {area, cardIsActive, toggleTag, isAgenda, task: taskRef, useTaskChild} = props
  const task = useFragment(
    graphql`
      fragment TaskFooter_task on Task {
        id
        error
        integration {
          __typename
        }
        tags
        team {
          id
        }
        userId
        ...TaskFooterTeamAssignee_task
        ...TaskFooterUserAssignee_task
        ...TaskFooterTagMenu_task
        ...TaskFooterIntegrateMenuRoot_task
      }
    `,
    taskRef
  )
  const {onCompleted, onError, submitMutation, submitting} = useMutationProps()
  const handleError = (err) => {
    onError(err)
    if (err.message) {
      setLocalTaskError(atmosphere, taskId, err.message)
    }
  }
  const handleCompleted = (res, errors) => {
    onCompleted(res, errors)
    const payload = _optionalChain([res, 'optionalAccess', _ => _[Object.keys(res)[0]]])
    const error = _nullishCoalesce(_nullishCoalesce(_optionalChain([payload, 'optionalAccess', _2 => _2.error, 'optionalAccess', _3 => _3.message]), () => ( _optionalChain([errors, 'optionalAccess', _4 => _4[0], 'optionalAccess', _5 => _5.message]))), () => ( null))
    setLocalTaskError(atmosphere, taskId, error)
  }

  const mutationProps = {
    onCompleted: handleCompleted,
    submitMutation,
    submitting,
    onError: handleError
  }
  const atmosphere = useAtmosphere()
  const showTeam = area === USER_DASH
  const {id: taskId, error, integration, tags, userId} = task
  const isArchived = isTaskArchived(tags)
  const canAssignUser = !integration && !isArchived
  const canAssignTeam = !isArchived
  return (
    _jsxs(Fragment, { children: [
      _jsxs(Footer, { children: [
        _jsx(AvatarBlock, { children: 
          showTeam ? (
            _jsx(TaskFooterTeamAssignee, {
              canAssign: canAssignTeam,
              task: task,
              useTaskChild: useTaskChild,}
            )
          ) : (
            _jsx(TaskFooterUserAssignee, {
              area: area,
              canAssign: canAssignUser,
              task: task,
              useTaskChild: useTaskChild,}
            )
          )
        })
        , _jsxs(ButtonGroup, { cardIsActive: cardIsActive, children: [
          integration || isArchived || !userId ? (
            _jsx(ButtonSpacer, {} )
          ) : (
            _jsx(TaskFooterIntegrateToggle, {
              mutationProps: mutationProps,
              task: task,
              useTaskChild: useTaskChild,}
            )
          )
          , isArchived ? (
            _jsx(CardButton, { onClick: () => toggleTag('archived'), children: 
              _jsx(IconLabel, { icon: "reply",} )
            })
          ) : (
            _jsx(TaskFooterTagMenuToggle, {
              area: area,
              toggleTag: toggleTag,
              isAgenda: isAgenda,
              task: task,
              useTaskChild: useTaskChild,
              mutationProps: mutationProps,}
            )
          )
        ]})
      ]})
      , error && _jsx(OutcomeCardMessage, { onClose: handleCompleted, message: error,} )
    ]})
  )
}

export default TaskFooter
